import axios from './api'

const teamTemplateDraftsService = {
  
  getTeamTemplateDrafts: (teamTemplateId, params = {}) => {
    return axios.get(`/team-template-drafts/${teamTemplateId}/drafts`, { params })
  },

  
  getTeamTemplateDraft: (id) => {
    return axios.get(`/team-template-drafts/${id}`)
  },

  
  createTeamTemplateDraft: (teamTemplateId, data) => {
    return axios.post(`/team-template-drafts/${teamTemplateId}/drafts`, data)
  },

  
  updateTeamTemplateDraft: (id, data) => {
    return axios.put(`/team-template-drafts/${id}`, data)
  },

  
  deleteTeamTemplateDraft: (id) => {
    return axios.delete(`/team-template-drafts/${id}`)
  },

  
  executeApiCall: (id, parameters = {}) => {
    return axios.post(`/team-template-drafts/${id}/execute-api`, { parameters })
  },

  
  downloadExcelTemplate: (id) => {
    return axios.get(`/team-template-drafts/${id}/download-excel`, {
      responseType: 'blob'
    })
  },

  
  uploadExcelFile: (id, file) => {
    const formData = new FormData()
    formData.append('excelFile', file)
    
    return axios.post(`/team-template-drafts/${id}/upload-excel`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}

export default teamTemplateDraftsService 